<app-dialog [title]="
'Select Vendor'
"
 
(close)="close()">
  <mat-dialog-content class="mat-dialog-content">
    <div class="add-sku">

      <div class="items-list thin-scrollbars" cdkScrollable>
        <div class="data-table">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Product</th>
                <th>Price</th>
                <th>Vendor</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="item-list_checkbox">
                    <i class="fas fa-check-circle"></i>
                  </div>
                </td>
                <td>
                  <div class="item">
                    <div class="item_image" [ngStyle]="{
                      'background-image': 'url(' + image + ')'
                    }" *ngIf="image">
                        </div>
                        <div class="item_header">
                          <div class="item_title">{{ name | lowercase }}</div>
                          <div class="item_chip-wrapper">
                            <app-sku-chip [name]="'id'" [value]="id" (click)="stopPropagation($event)"></app-sku-chip>
                          </div>
                        </div>
                  </div>
                </td>
                <td>$120</td>
                <td>ABC</td>

              </tr>
            </tbody>
          </table>

        </div>

      </div>
    </div>
  </mat-dialog-content>
</app-dialog>